window.externalLinkModalContainer = null;

/**
 * Show external link warning modal
 * @param {HTMLElement} linkElement - The anchor element that was clicked
 */
const showExternalLinkModal = (linkElement) => {
  if (window.externalLinkModalContainer !== null) {
    window.externalLinkModalContainer.remove();
  }

  const targetUrl = linkElement.getAttribute("href");
  const title = window.I18n.t('external_link.title');
  const message = window.I18n.t('external_link.message');
  const continueButton = window.I18n.t('external_link.continue');
  const dismissButton = window.I18n.t('external_link.dismiss');

  window.externalLinkModalContainer = document.createElement('div');
  window.externalLinkModalContainer.innerHTML = `
    <dialog class="nv-modal nv-modal-cozy external-link-modal">
      <div class="nv-modal-header">
        <div class="nv-modal-title">${title}</div>
        <div class="nv-modal-close-button"></div>
      </div>
      <div class="nv-modal-body">
        <p>${message}</p>
      </div>
      <div class="nv-modal-footer">
        <button type="button" class="nv-cta-secondary-alt dismiss-external-link">${dismissButton}</button>
        <a href="${targetUrl}" class="nv-cta-primary continue-external-link">${continueButton}</a>
      </div>
    </dialog>
  `;

  document.body.append(window.externalLinkModalContainer);

  const dialog = window.externalLinkModalContainer.querySelector('.external-link-modal');
  
  // Show the modal using HTML5 dialog API
  if (dialog && typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else if (dialog) {
    dialog.setAttribute('open', 'true');
  }

  const closeModal = () => {
    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
    if (window.externalLinkModalContainer) {
      window.externalLinkModalContainer.remove();
      window.externalLinkModalContainer = null;
    }
  };

  // Handle dismiss button
  const dismissBtn = window.externalLinkModalContainer.querySelector('.dismiss-external-link');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', closeModal);
  }

  // Handle close button
  const closeBtn = window.externalLinkModalContainer.querySelector('.nv-modal-close-button');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Handle click outside the modal content
  if (dialog) {
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        closeModal();
      }
    });
  }

  // Handle ESC key
  if (dialog) {
    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      closeModal();
    });
  }
};

// Initialize the event listener for links with the data-external-link attribute
document.addEventListener('click', function(event) {
  const target = event.target.closest('a[data-external-link]');
  
  if (target) {
    event.preventDefault();
    showExternalLinkModal(target);
  }
}, false);
